module.exports = __webpack_public_path__ + "static/media/partner-logo15.d397b704.png";